<template>
    <div v-if="value">
        <div class="grid gap-8 grid-cols-2">
            <input-text
                label="Rubrik"
                v-model:content="value.title"
            />
            <input-select
                label="Textfärg"
                name="textColor"
                :options="textColorOptions"
                v-model:content="value.text_color"
            ></input-select>
        </div>
        <input-media-bank-entry
            type="image"
            label="Välj en bild från mediabiblioteket"
            required
            v-model:content="value.media_bank_entry_id"
        />
        <media-bank-entries-display v-if="value.media_bank_entry_id" :data-url="route('mediaBank.entries.show', value.media_bank_entry_id)" />
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
export default {
    props: {
        modelValue: {},
        layout: {
            type: String,
            default: 'full'
        }
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null,
            textColorOptions: [
                { value: 'theme', label: 'Följ färgtema' },
                { value: 'light', label: 'Ljus' },
                { value: 'dark', label: 'Mörk' },
            ]
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) { return; }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        }
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.title) { value.title = null; }
            if (!value.media_bank_entry_id) { value.media_bank_entry_id = null; }
            if (!value.text_color) { value.text_color = 'theme'; }
            this.value = value;
        },
    },
}
</script>
